import React, { ReactElement, ReactNode } from 'react'

import { Tooltip } from '@mui/material'

const BaseTooltip: React.SFC<BaseTooltipProps> = ({
  children,
  title,
  instant = false,
  bottom = false,
  wrapped = false,
}) => {
  if (!title) {
    return children
  }
  return (
    <Tooltip
      title={title}
      enterDelay={instant ? 0 : 300}
      leaveDelay={instant ? 0 : 150}
      placement={bottom ? 'bottom' : 'top'}
    >
      {wrapped ? <span style={{ display: 'inline-block', fontSize: 0 }}>{children}</span> : children}
    </Tooltip>
  )
}
export default BaseTooltip

type BaseTooltipProps = {
  children: ReactElement<any>
  title: ReactNode | string
  instant?: boolean
  bottom?: boolean
  wrapped?: boolean
}
